__webpack_public_path__ = process.env.VUE_APP_BASE_URL;

import Vue from 'vue';
import App                           from './App.vue';
import i18n                          from './libraries/i18n.js';
import VueScreen                     from 'vue-screen';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueNumberFormat               from 'vue-number-format'
import vueNumeralFilterInstaller     from 'vue-numeral-filter';

// Import vue libraries
import router     from './libraries/VueRouter.js';
import VueHead    from 'vue-head';
import VueSession from 'vue-session';

// Import animate on scroll
import AOS from 'aos'

// Font awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight, faHome, faChevronDown, faPlus, faMinus, faChevronRight, faCheck, faChevronLeft} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(faArrowRight, faHome, faChevronDown, faPlus, faMinus, faChevronRight, faCheck, faChevronLeft);

// Bootstrap
require('bootstrap');
Vue.use(VueScreen, 'bootstrap');

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

// Import Sass styling
import './assets/scss/app.scss';

// Import component
import Header             from './components/header/Header.vue';
import CategoryInfo       from './components/layouts/CategoryInfo.vue';
import Footer             from './components/footer/Footer.vue';
import Settings           from './components/layouts/Settings.vue';
import HeaderFontButton   from './components/header/HeaderFontButton.vue';
import HeaderLocaleButton from './components/header/HeaderLocaleButton.vue';

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);

// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);

// Make the prod tips disapear
Vue.config.productionTip = false;

// Global components
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('global-header', Header);
Vue.component('category-info', CategoryInfo);
Vue.component('global-footer', Footer);
Vue.component('header-font-button', HeaderFontButton);
Vue.component('header-locale-button', HeaderLocaleButton);
Vue.component('settings', Settings);

// Use libraries
Vue.use(VueHead);
Vue.use(VueSession);
Vue.use(VueNumberFormat)

// Register new numeral for globalmap.
var numeral = require('numeral');
numeral.register('locale', 'globalmap', {
    delimiters: {
        thousands: ',',
        decimal: '.'
    },
    abbreviations: {
        thousand: 'K',
        million: 'M',
        billion: 'B',
        trillion: 'T'
    },
    ordinal: function (number) {
        var b = number % 10;
        return (~~ (number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
    },
    currency: {
        symbol: '$'
    }
});

// Use the new numeral (en-globalmap).
Vue.use(vueNumeralFilterInstaller, { locale: 'globalmap' });

new Vue({
    i18n,
    router,
    render: h => h(App),
    created () {
        const getHTMLTag = document.documentElement;
        getHTMLTag.setAttribute("lang", i18n.locale);
    },
    mounted() {
        AOS.init({
            offset: 10
        });
    },
}).$mount('#app');
